import { render, staticRenderFns } from "./Soussol.vue?vue&type=template&id=8d252fbe&"
import script from "./Soussol.vue?vue&type=script&lang=js&"
export * from "./Soussol.vue?vue&type=script&lang=js&"
import style0 from "./Soussol.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports